import Input from '../../../../../Core/Fields/Floating/Input';
import TextArea from '../../../../../Core/Fields/Floating/Textarea';
import SelectSearchApi from '../../../../../Core/Fields/Floating/SelectSearchApi';

const AddressAndContactTab = ({companyinfo, formData, onFieldChange,addressData,territoryData,place_of_supplyData,contactPersonData, shippingDispatchAddressData, companyContactPersonData }) => {

    const primaryAddress = companyinfo?.message?.data?.address_list?.[0];
    const formattedAddress = primaryAddress ? 
        `${primaryAddress.address_line1 || ''}\n${primaryAddress.address_line2 || ''}\n${primaryAddress.city || ''}, ${primaryAddress.state || ''} ${primaryAddress.pincode || ''}\n${primaryAddress.country || ''}${primaryAddress.phone ? `\nPhone: ${primaryAddress.phone}` : ''}`
        : '';

    return (
        <div>
            <div className="px-2 py-3" style={{ background: 'white' }}>
                <div style={{ display: 'flex', gap: '15px' }} >
                    
                    {/* Billing Address Section */}
                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Billing Address</p>
                                </div>
                            </div>
                            
                            <div style={{ display: 'flex', gap: '15px', marginTop: '10px' }}>
                                <div style={{ flex: 1 }}>
                                    <SelectSearchApi
                                        label="Customer Address"
                                        list={addressData.billingAddress_List}
                                        getOptionLabel={(item) => item.value}
                                        getOptionValue={(item) => item.value}
                                        style={{ height: "30px" }}
                                        value={formData.billing_address}
                                        onChange={(e) => onFieldChange('billing_address', e)}
                                        onApiChange={(e) => addressData.refetch_billingAddress(e)}
                                    />
                                  
                                </div>

                                 <div style={{ flex: 1 }}>
                                    {/* <Input
                                        label="Contact Person"
                                        style={{ height: "30px" }}
                                        value={formData.contact_person}
                                        onChange={(e) => onFieldChange('contact_person', e.target.value)}
                                    /> */}
                                    <SelectSearchApi
                                        label="Contact Person"
                                        list={contactPersonData.billingContactPerson_List}
                                        getOptionLabel={(item) => item.label}
                                        getOptionValue={(item) => item.value}
                                        style={{ height: "30px" }}
                                        value={formData.billing_contact_person}
                                        onChange={(e) => onFieldChange('billing_contact_person', e)}
                                        onApiChange={(e) => contactPersonData.refetch_billingAddress_Person(e)}
                                    />
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: '15px', marginTop: '10px' }}>
                                <div style={{ flex: 1 }}>
                                    <Input
                                        label="GST Category"
                                        style={{ height: "30px" }}
                                        value={formData?.gstDetails?.gst_category}
                                        readOnly
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    {/* <Input
                                        label="Territory"
                                        style={{ height: "30px" }}
                                        value={formData.territory}
                                        onChange={(e) => onFieldChange('territory', e.target.value)}
                                    /> */}

                                    <SelectSearchApi
                                        label="Territory"
                                        list={territoryData.territory_List}
                                        getOptionLabel={(item) => item.value}
                                        getOptionValue={(item) => item.value}
                                        style={{ height: "30px" }}
                                        value={formData.territory}
                                        onChange={(e) => onFieldChange('territory', e)}
                                        onApiChange={(e) => territoryData.refetch_territory(e)}
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                               
                                      <SelectSearchApi
                                        label="Place of Supply"
                                        list={place_of_supplyData.place_of_supply_List}
                                        getOptionLabel={(item) => item.value}
                                        getOptionValue={(item) => item.value}
                                        style={{ height: "30px" }}
                                        value={formData.place_of_supply}
                                        onChange={(e) => onFieldChange('place_of_supply', e)}
                                        onApiChange={(e) => {}}
                                    />
                                </div>
                            </div>

                            {/* Shipping Address */}
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Shipping Address</p>
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: '15px', marginTop: '10px' }}>
                                <div style={{ flex: 1 }}>
                                     <SelectSearchApi
                                        label="Shipping Address Name"
                                        list={addressData.billingAddress_List}
                                        getOptionLabel={(item) => item.value}
                                        getOptionValue={(item) => item.value}
                                        style={{ height: "30px" }}
                                        value={formData.shipping_address}
                                        onChange={(e) => onFieldChange('shipping_address', e)}
                                        onApiChange={(e) => addressData.refetch_billingAddress(e)}
                                    />
                                </div>

                                 <div style={{ flex: 1 }}>
                               

                                     <SelectSearchApi
                                        label="Dispatch Address Name"
                                        list={shippingDispatchAddressData.shipping_dispatch_address_List}
                                        getOptionLabel={(item) => item.value}
                                        getOptionValue={(item) => item.value}
                                        style={{ height: "30px" }}
                                        value={formData.shipping_dispatch_address}
                                        onChange={(e) => onFieldChange('shipping_dispatch_address', e)}
                                        onApiChange={(e) => shippingDispatchAddressData.refetch_shipping_dispatch_address(e)}
                                    />
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: '15px', marginTop: '10px' }}>
                                <div style={{ flex: 1 }}>
                                    <TextArea
                                        label="Shipping Address"
                                        style={{ height: "60px" }}
                                        value={formData?.full_shipping_address?.replace(/<br\s*\/?>/gi, ' ').replace(/\\n/g, '\n').trim()}
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Shipping Address & Company Details Section */}
                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            
                           {/* Company Address */}
                            <div style={{ display: 'flex', gap: '15px', marginTop: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Company Address</p>
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: '15px', marginTop: '10px' }}>
                                <div style={{ flex: 1 }}>
                                     {/* <Input
                                        label="Company Address Name"
                                        style={{ height: "30px" }}
                                        value={companyinfo.message?.data?.company}
                                        readOnly
                                    /> */}

                                      <SelectSearchApi
                                        label="Company Address Name"
                                        list={shippingDispatchAddressData.shipping_dispatch_address_List}
                                        getOptionLabel={(item) => item.value}
                                        getOptionValue={(item) => item.value}
                                        style={{ height: "30px" }}
                                        value={formData.company_address}
                                        onChange={(e) => onFieldChange('company_address', e)}
                                        onApiChange={(e) => shippingDispatchAddressData.refetch_shipping_dispatch_address(e)}
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                     <SelectSearchApi
                                        label="Company Contact Person"
                                        list={companyContactPersonData.companyContactPerson_List}
                                        getOptionLabel={(item) => item.label}
                                        getOptionValue={(item) => item.value}
                                        style={{ height: "30px" }}
                                        value={formData.company_Address_Person}
                                        onChange={(e) => onFieldChange('company_Address_Person', e)}
                                        onApiChange={(e) => companyContactPersonData.refetch_company_Address_Person(e)}
                                    />
                                </div>
                            </div>

                            {/* Address Details */}
                            <div style={{ display: 'flex', gap: '15px', marginTop: '10px' }}>
                                <div style={{ flex: 1 }}>
                                     <Input
                                        label="Company GSTIN"
                                        style={{ height: "30px" }}
                                        value={companyinfo?.message?.data?.gstin}
                                        readOnly
                                    />
                                </div>

                                <div style={{ flex: 1 }}>
                                    <TextArea
                                        label="Company Address"
                                        style={{ height: "60px" }}
                                        value={formattedAddress}
                                        readOnly
                                    />
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default AddressAndContactTab;